import ticket from "./ticket.component";
import ticketUrls from "./ticket.urls";
import TicketTransforms from "./ticket.transforms";

const ticketModule = angular
  .module("app.components.ticket", [])
  .component("ticketPage", ticket)
  .service("TicketTransforms", TicketTransforms)
  .config(ticketUrls);

export default ticketModule;



// WEBPACK FOOTER //
// ./src/pages/ticket/ticket.module.js